import { z } from 'zod';
import { apiFetch } from '@/api';
import { TicketContentRefSchema, type TicketContentRef } from '@shared/schemas';

/**
 * Client ticket-body loader · fetches from the gated edge `content` function
 * (slot_content_protection Phase 1 · 29 JUN 2026). Replaces the old bundled
 * dynamic-import loader — course bodies no longer ship in the client build, so
 * the server (role + progression gate) decides what the user may receive.
 *
 * Returns `undefined` on any failure (403 not-entitled / 404 / network) so the
 * caller renders a graceful empty/locked state rather than throwing — same
 * contract as the previous bundled `loadTicketBody`. The client UX gate
 * (access.ts) normally prevents navigating to a non-entitled ticket; this is the
 * server-enforced backstop.
 */
const BodyResponse = z.object({ body: TicketContentRefSchema });

export async function loadTicketBody(ticketId: string): Promise<TicketContentRef | undefined> {
  try {
    const { body } = await apiFetch(
      BodyResponse,
      `/api/content/ticket/${encodeURIComponent(ticketId)}`,
    );
    return body;
  } catch {
    return undefined;
  }
}
